import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FichaAdmisionFacadeService } from '../ficha-admision/ficha-admision-facade.service';
import { MatDialog } from '@angular/material';
import { HomePageFacadeService } from './home-page-facade.service';

@Component({
  selector: 'app-oferta-academica',
  templateUrl: './oferta-academica.component.html',
  styleUrls: ['./oferta-academica.component.css'],
  encapsulation: ViewEncapsulation.Emulated
})
export class OfertaAcademicaComponent implements OnInit {

  public maestrias:any[] = [];
  public filteredPosgrados: any[] = [];
  public idCentro = new FormControl('', [Validators.required]);
  public idFacultad = new FormControl('', [Validators.required]);
  public selectedItem: any;
  public centroSeleccionado:boolean = false;
  public nombreCentro:string = "";
  public selecionSiEsEstudiante:boolean = null;
  public selecionSiEsEmpleado:boolean = null;
  public idCentroVirtual: any;

  public nombrePosgrado = new FormControl('');
    public filtroPosgrado = new FormControl('');


  public centrosRegionales:any[] = [
    {
      imagen: 'https://presencia.unah.edu.hn/assets/Uploads/0a635c9e15/Agua-residual__FillWzg0MCw1NTBd.jpg',
      nombreCentro: 'Ciudad Universitaria',
      siglasCentro: 'UNAH-CU'
    },
    {
      imagen: 'https://presencia.unah.edu.hn/assets/Uploads/0a635c9e15/Agua-residual__FillWzg0MCw1NTBd.jpg',
      nombreCentro: 'UNAH Valle de Sula',
      siglasCentro: 'UNAH-VS'
    },
    {
      imagen: 'https://presencia.unah.edu.hn/assets/Uploads/0a635c9e15/Agua-residual__FillWzg0MCw1NTBd.jpg',
      nombreCentro: 'Centro Universitario Regional de Litoral Atlántico',
      siglasCentro: 'UNAH-CURLA'
    },
    {
      imagen: 'https://presencia.unah.edu.hn/assets/Uploads/0a635c9e15/Agua-residual__FillWzg0MCw1NTBd.jpg',
      nombreCentro: 'Centro Tecnológico del Valle de Aguan',
      siglasCentro: 'UNAH-TEC AGUÁN'
    }
  ];

  public posgrados:any[] = [];
  public PosgradosAll:any[]  = [];
  formEstudiante: FormGroup;
  estudianteEncontrado: boolean = false;
  estudianteBuscar: boolean = true;
  noEstudiante: boolean = true;

  private currentDialog: any;
  responseEgresado: any[] = [];
  responseEmpleado: any[] = [];
  requisitos: any[] = [];

  public suscripciones:Subscription = new Subscription();



  constructor(public modal: MatDialog,public router:Router, public fichaAdmisionFacade:FichaAdmisionFacadeService,private fb: FormBuilder, public HomePageFacade: HomePageFacadeService,private cdr: ChangeDetectorRef) { 
    this.fichaAdmisionFacade.mostrarDatosGenerales('');
    // this.formEstudiante = this.fb.group({
    //   numeroCuenta: [''],
    //   identidad: [''],
    //   correoInstitucional: [''],
    //   primerNombre: [''],
    //   segundoNombre: [''],
    //   primerApellido: [''],
    //   segundoApellido: [''],
    //   genero: [''],
    //   estadoCivil: [''],
    //   fechaNacimiento: [''],
    //   lugarNacimiento: [''],
    //   paisNacionalidad: [''],
    //   direccionResidencia: [''],
    //   telefonoCelular: ['']
    // });
    this.suscripciones.add(
      this.fichaAdmisionFacade.responseDatosGenerales$.subscribe((result:any)=>{
        // console.log(result?.Table13)
        if(result?.Table13?.length > 0){
          this.PosgradosAll = result.Table13;
        
        }
      })
    );
    this.formEstudiante = new FormGroup({
      CodigoEmpleado: new FormControl(''),
      numeroCuenta: new FormControl(''),
      identidad: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    localStorage.removeItem('Egresado');
  }

  seleccionarCentro(centro){
    this.nombrePosgrado = null
    this.centroSeleccionado = true;
    this.nombreCentro = centro.nombreCentro;
    this.idCentroVirtual = centro.idCentro

    console.log("aaa",this.PosgradosAll)
if ( this.idCentroVirtual === 39){
  this.posgrados = this.PosgradosAll.filter(p => p.idModalidad === 2  );
}
else{


    this.posgrados = this.PosgradosAll.filter(p => p.idCentro === centro.idCentro && p.idModalidad !== 2);

}
    this.filteredPosgrados =  this.posgrados 
    console.log("ss", this.filteredPosgrados )
  }

  solicitarIngreso(item,eleccion: number){
    this.cerrarModal()
    // console.log(item)
    localStorage.setItem("carreraSeleccionada", JSON.stringify(item));
    if (eleccion == 1) {
      if (this.selecionSiEsEstudiante === true && (this.selecionSiEsEmpleado === true  || this.selecionSiEsEmpleado === false )){
      if (this.responseEgresado && this.responseEgresado.length > 0) {
          localStorage.setItem("Egresado", JSON.stringify(this.responseEgresado));
      }
    }
    if(this.selecionSiEsEstudiante === false &&  this.selecionSiEsEmpleado === true){
      eleccion = 3
    if (this.responseEmpleado && this.responseEmpleado.length > 0) {
      localStorage.setItem("Egresado", JSON.stringify(this.responseEmpleado));
    }
}
  }
    
    this.router.navigateByUrl(`fichaAdmision/${item.idCentro}/${item.idCarrera}/${eleccion}`);
    localStorage.removeItem('DatosGenerales');// Borra los datos del localStorage
    localStorage.removeItem('DatosAcademicos'); 
    localStorage.removeItem('DatosLaborales');
  }
  filtrarPosgrados(query: string): void {
    // Convierte la consulta a minúsculas y la normalizamos para eliminar tildes
    const normalizarTexto = (texto: string) => 
      texto.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  
    const lowerCaseQuery = normalizarTexto(query);
  
    this.filteredPosgrados = this.posgrados.filter(posgrado => 
      normalizarTexto(posgrado.nombrePosgrado).includes(lowerCaseQuery)
    );
  }

  openModal(template: TemplateRef<any>, item: any) {
    this.requisitos = [];
    this.HomePageFacade.limpiarrequisitos();
    this.cdr.detectChanges();

    this.selectedItem = item;
  
    const params = {
      idCarrera: item.idCarrera,
    };
     this.HomePageFacade.mostrarrequisitoMaster(params).subscribe({
    next: (response) => {
      this.requisitos = response.data.Table0; // Guarda los requisitos recibidos
    },
    error: (err) => {
      console.error('Error al obtener requisitos:', err);
      this.requisitos = []; // Asegúrate de limpiar la lista en caso de error
    },
  });
  const screenWidth = window.innerWidth;
  // Establecer el ancho del modal según el tamaño de la pantalla
  let modalWidth = screenWidth < 760 ? '90%' : '40%'; 
    this.currentDialog  = this.modal.open(template, {
      width: modalWidth,
      panelClass: "app-full-bleed-dialog",
      disableClose: true

    });

    this.suscripciones.add(this.currentDialog .afterClosed().subscribe((result) => { }));
  }

  openModalsolicitud(template: TemplateRef<any>, item: any) {
    this.estudianteEncontrado = false;
    this.estudianteBuscar= true;
    this.HomePageFacade.limpiarEgresado(); 
    this.responseEgresado = []
    this.responseEmpleado = []
    this.noEstudiante = true;

    this.selectedItem = item; // Guardar el item en una propiedad del componente
    if (this.currentDialog) {
      this.currentDialog.close();
    }
    const screenWidth = window.innerWidth;
    // Establecer el ancho del modal según el tamaño de la pantalla
    let modalWidth = screenWidth < 760 ? '90%' : '40%'; 
   this.currentDialog  = this.modal.open(template, {
        width: modalWidth,
        panelClass: "app-full-bleed-dialog",
        disableClose: true,
    });

    this.suscripciones.add(this.currentDialog .afterClosed().subscribe((result) => { }));
}
openModalBuscar(template: TemplateRef<any>, item: any, Empleado: boolean): void {
this.formEstudiante.get(`CodigoEmpleado`).setValue(null);
this.formEstudiante.get(`numeroCuenta`).setValue(null);
this.formEstudiante.get(`identidad`).setValue(null);

  this.selectedItem = item; // Guardar el item en una propiedad del componente
  if (Empleado) {
    this.selecionSiEsEmpleado = true
} else {
    this.selecionSiEsEmpleado = false
    
}
if(this.selecionSiEsEmpleado === false){
this.formEstudiante = new FormGroup({
  // CodigoEmpleado: new FormControl(''),
  numeroCuenta: new FormControl('',[Validators.required]),
  identidad: new FormControl('', [Validators.required]),
});
}
if(this.selecionSiEsEmpleado === true){
  this.formEstudiante = new FormGroup({
    CodigoEmpleado: new FormControl('',[Validators.required]),
    // numeroCuenta: new FormControl('',[Validators.required]),
    identidad: new FormControl('', [Validators.required]),
  });
  }
  if(this.selecionSiEsEstudiante === true  && ( this.selecionSiEsEmpleado === true || this.selecionSiEsEmpleado === false )){
    this.formEstudiante = new FormGroup({
      CodigoEmpleado: new FormControl(''),
      numeroCuenta: new FormControl('',[Validators.required]),
      identidad: new FormControl('', [Validators.required]),
    });
  }
  if(this.selecionSiEsEstudiante === false  && this.selecionSiEsEmpleado === true ){
    this.formEstudiante = new FormGroup({
      CodigoEmpleado: new FormControl('',[Validators.required]),
      numeroCuenta: new FormControl(''),
      identidad: new FormControl('', [Validators.required]),
    });
    
  }

    const screenWidth = window.innerWidth;
    // Establecer el ancho del modal según el tamaño de la pantalla
    let modalWidth = screenWidth < 760 ? '90%' : '40%'; 

   this.currentDialog  = this.modal.open(template, {
      width: modalWidth,
      panelClass: "app-full-bleed-dialog",
      disableClose: true,
  });

  this.suscripciones.add(this.currentDialog .afterClosed().subscribe((result) => { }));
}

openEmpleado(template: TemplateRef<any>, item: any, esAlumno: boolean): void {
  if (esAlumno) {
    this.selecionSiEsEstudiante = true
} else {
    this.selecionSiEsEstudiante = false
}
  this.selectedItem = item; // Guardar el item en una propiedad del componente
  const screenWidth = window.innerWidth;
  // Establecer el ancho del modal según el tamaño de la pantalla
  let modalWidth = screenWidth < 760 ? '90%' : '40%'; 
   this.currentDialog  = this.modal.open(template, {
      width: modalWidth,
      panelClass: "app-full-bleed-dialog",
      disableClose: true,
  });

  this.suscripciones.add(this.currentDialog .afterClosed().subscribe((result) => { }));
}

  cerrarModal() {
    //modal para cerrar 
    this.requisitos = [];
    this.HomePageFacade.limpiarrequisitos();

    this.modal.closeAll();
    this.estudianteEncontrado = false;
    this.estudianteBuscar= true;
     // Reiniciar los datos de responseEgresado$
     this.HomePageFacade.limpiarEgresado(); 
    }

  buscarEstudiante() {
    if(this.formEstudiante.invalid){
      this.formEstudiante.markAllAsTouched();
     
      return;
    }
    this.estudianteEncontrado = false;
    this.noEstudiante = false; 

    // Obtener valores del formulario
    const numeroCuenta = this.formEstudiante.get('numeroCuenta')?.value;
    const rawValue = this.formEstudiante.get('identidad')?.value;
    const identidad = rawValue != null ? String(rawValue) : '';
    // const identidad = this.formEstudiante.get('identidad')?.value;
 
   if(this.selecionSiEsEstudiante === true && ( this.selecionSiEsEmpleado === true || this.selecionSiEsEmpleado === false )){

    const params = {
      Cuenta: numeroCuenta,
      Identidad: identidad,
    };
  
    // Llamar a la API para buscar al egresado
    this.HomePageFacade.mostrarEgresado(params).subscribe({
      next: (response) => {
        if (response) {
          // console.log('Respuesta recibida:', response);
          if (response && response.data && response.data.Table0) {
           

            this.responseEgresado = response.data.Table0;
            // console.log('Respuesta recibida:',this.responseEgresado);
          }
          this.estudianteEncontrado = true;
          this.estudianteBuscar= false;
          this.noEstudiante = true;
        } else {
          this.estudianteEncontrado = false;
          this.estudianteBuscar= true;
          this.noEstudiante = false;

          
          
        }
      },
      error: (err) => {
        console.error('Error al buscar estudiante:', err);
        this.estudianteEncontrado = false;
        this.estudianteBuscar= true;
        this.noEstudiante = true;
      },
    });

  }
  if(this.selecionSiEsEstudiante === false &&  this.selecionSiEsEmpleado === true){
    const CodigoEmpleado = this.formEstudiante.get('CodigoEmpleado')?.value;
    const params = {
      CodEmpleado: CodigoEmpleado,
      Identidad: identidad,
    };
  
    this.HomePageFacade.mostrarEmpleado(params).subscribe({
      next: (response) => {
        if (response) {
          console.log('Respuesta recibida:', response);
          if (response && response.data && response.data.Table0) {
           

            this.responseEmpleado = response.data.Table0;
            console.log('Respuesta recibida:',this.responseEmpleado);
          }
          this.estudianteEncontrado = true;
          this.estudianteBuscar= false;
          this.noEstudiante = true;
        } else {
          this.estudianteEncontrado = false;
          this.estudianteBuscar= true;
          this.noEstudiante = false;

          
          
        }
      },
      error: (err) => {
        console.error('Error al buscar estudiante:', err);
        this.estudianteEncontrado = false;
        this.estudianteBuscar= true;
        this.noEstudiante = true;
      },
    });

  }


}

  // Función para permitir solo números
  allowOnlyNumbers(event: KeyboardEvent) {
    const key = event.key;
    // Permitir teclas de navegación
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(key)) {
      return; 
    }

    // Valida que el valor sea un número
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault(); // Prevenir la entrada si no es un número
    }
  }
}
